import Filter from '@mui/icons-material/FilterList';
import { Box } from '@ovComponents/1-primative/box/box';
import { Typography } from '@ovComponents/1-primative/typography/typography';
import { Button } from '@ovComponents/2-component/button/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogTitle,
} from '@ovComponents/2-component/dialog/dialog';
import { IconButton } from '@ovComponents/2-component/iconButton/iconButton';
import { Switch } from '@ovComponents/2-component/switch/switch';
import { useThemeTokens } from '@providers/themeTokenProvider';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AlertBannerStatus } from '../types';

export default function alertBannerFilterModal({
  initialStatuses,
  filterExists,
  onApply,
}: {
  initialStatuses: AlertBannerStatus[];
  onApply: (status: AlertBannerStatus[]) => void;
  filterExists: boolean;
}) {
  const { sys } = useThemeTokens();
  const { t } = useTranslation('alertBanners');
  const [open, setOpen] = useState(false);
  const [statuses, setStatuses] =
    useState<AlertBannerStatus[]>(initialStatuses);

  const handleCancel = () => {
    setOpen(false);
    setStatuses(initialStatuses);
  };

  return (
    <>
      <Box position='relative'>
        <IconButton onClick={() => setOpen(true)}>
          <Filter />
        </IconButton>
        {filterExists && (
          <Box
            position='absolute'
            top='8px'
            right='8px'
            height='8px'
            width='8px'
            borderRadius='50%'
            sx={{
              backgroundColor: sys.color.negative,
            }}
          />
        )}
      </Box>
      <Dialog
        open={open}
        fullWidth
        maxWidth='sm'
        sx={{
          '.MuiDialog-container': {
            alignItems: 'flex-start',
            paddingTop: 2,
          },
        }}
      >
        <DialogTitle onClose={handleCancel}>
          <Typography variant='headingMedium'>
            {t('filterModal.title')}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Box display='flex' flexDirection='column' gap={2} py={1}>
            <Typography variant='bodyLarge' color={sys.color.onSurfaceVariant}>
              {t('filterModal.status')}
            </Typography>
            {Object.values(AlertBannerStatus).map((status) => (
              <Switch
                key={status}
                label={t('filterModal.showStatus', {
                  status: t(`table.status.states.${status}`),
                })}
                fullWidth
                labelPosition='left'
                checked={statuses.includes(status)}
                onChange={(checked) =>
                  setStatuses((prev) =>
                    checked
                      ? [...prev, status]
                      : prev.filter((x) => x !== status),
                  )
                }
                sx={{
                  '& .MuiTypography-root': {
                    color: sys.color.onSurface,
                  },
                }}
              />
            ))}
          </Box>
        </DialogContent>
        <DialogFooter>
          <Box display='flex' justifyContent='flex-end' gap={1} p={1}>
            <Button
              label={t('filterModal.cancel')}
              onClick={handleCancel}
              variant='tonal'
            />
            <Button
              label={t('filterModal.apply')}
              onClick={() => {
                onApply(statuses);
                setOpen(false);
              }}
            />
          </Box>
        </DialogFooter>
      </Dialog>
    </>
  );
}
